export enum SupportTypes {
  LOGIN = 'login',
  PASSWORD_RESET_SUCCESS = 'password-reset-success',
  PARTNER_IDENTIFIER_HELP = 'partner-identifier-help',
  PROOFING_SIGNUP_ERROR = 'proofing-signup-error',
  PROOFING_NOT_MY_ACCOUNT = 'proofing-not-my-account'
}
